import { render } from "./NuevaPromocion.vue?vue&type=template&id=2556dfcc&scoped=true"
import script from "./NuevaPromocion.vue?vue&type=script&lang=js"
export * from "./NuevaPromocion.vue?vue&type=script&lang=js"

import "./NuevaPromocion.vue?vue&type=style&index=0&id=2556dfcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2556dfcc"]])

export default __exports__